function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.85355 1.64645C7.65829 1.45118 7.34171 1.45118 7.14645 1.64645C6.95118 1.84171 6.95118 2.15829 7.14645 2.35355L8.79289 4H4C3.33696 4 2.70107 4.26339 2.23223 4.73223C1.76339 5.20107 1.5 5.83696 1.5 6.5V10C1.5 10.2761 1.72386 10.5 2 10.5C2.27614 10.5 2.5 10.2761 2.5 10V6.5C2.5 6.10218 2.65804 5.72064 2.93934 5.43934C3.22064 5.15804 3.60218 5 4 5H8.79289L7.14645 6.64645C6.95118 6.84171 6.95118 7.15829 7.14645 7.35355C7.34171 7.54882 7.65829 7.54882 7.85355 7.35355L10.3536 4.85355C10.5488 4.65829 10.5488 4.34171 10.3536 4.14645L7.85355 1.64645Z"
  }));
};

export default SvgComponent;